import {HttpClient} from "@angular/common/http";
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class CompanyService {

    constructor(private http:HttpClient) {}

    get(){
        let requestUrl = environment.apiUrl + 'company/get';
        return this.http.get(requestUrl).map((res: any) => {
            return res;
        });
    }

    save(company){
        let requestUrl = environment.apiUrl + 'company/update/' + company.id;
        return this.http.post(requestUrl, company).map( (res: any) => {
            return res;
        });
    }
}


// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/company.service.ts